<div class="d-flex align-items-center justify-content-between mb-2">
    <h3 class="mb-0">Versões do plugin</h3>
    <button class="btn btn-primary" *ngIf="isAdmin()" [routerLink]="['/configurations/new']">Nova versão</button>
</div>
<div class="table-responsive">
    <ng-generate-table tableClass="table table-hover border-top" [columns]="columns" [data]="versions" />
</div>
<ng-template #deleteFooter>
    <div class="container-fluid">
        <div class="row row-cols-4 justify-content-end">
            <button type="button" class="btn btn-light me-2" (click)="closeModal()">Cancelar</button>
            <button type="button" class="btn btn-danger" (click)="deleteVersion()" [disabled]="loading.modal">
                <div class="spinner-border spinner-border-sm" role="status" *ngIf="loading.modal"></div>
                <span *ngIf="!loading.modal">Apagar</span>
            </button>
        </div>
    </div>
</ng-template>
